export default __webpack_public_path__ + "static/media/seven.ed9a36bb.jpg";